import { useState } from 'react';
import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/ui/Hero';
import CTA from '../../components/ui/CTA';
import FilterSection from './components/FilterSection';
import ArticlesGrid from './components/ArticlesGrid';

export default function ArticlesPage() {
  const [selectedCategory, setSelectedCategory] = useState('All Articles');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero 
        subtitle="Mastering the Digital Frontier"
        title={<>In-Depth Perspectives. <span className="gradient-text">Actionable Insights.</span></>}
        description="Explore our library of expert articles designed to elevate your understanding of today's complex digital landscape."
        bgImage="/assets/sophisticated-digital-library.png"
        gradient="from-gray-900 via-gray-800 to-black"
        primaryBtn={{ text: "Explore Knowledge Base", link: "#knowledge-base" }}
      />
      <FilterSection 
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
      />
      <ArticlesGrid 
        selectedCategory={selectedCategory}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        searchQuery={searchQuery}
      />
      <CTA 
        title="Partner with Thought Leaders"
        description="Our articles offer a glimpse into the expertise that drives our client success. If you're ready to apply these insights to your business, our team is here to help."
        primaryBtn={{ text: "Request a Consultation", link: "/contact", icon: "ri-mail-line" }}
        gradient="from-gray-900 via-gray-800 to-black"
      />
      <Footer />
    </div>
  );
}